@if (bankTransactionFamilyWidgetData && initialized) {
    <mvs-widget [widgetData]="bankTransactionFamilyWidgetData"></mvs-widget>
}
